export default "__VITE_PUBLIC_ASSET__c0e6c340__"